import RegisterCount from './RegisterCount';

export default RegisterCount;
